import React, { useEffect, useMemo, useRef } from "react";

// Sunucu HTML'i zaten temizlemiştir; yine de <script içeren içerik basılmaz.
function RichTextView({ html, resolveImage, className = "" }) {
  const ref = useRef(null);
  const cache = useRef(new Map());
  const safe = useMemo(() => {
    const h = html || "";
    return /<script/i.test(h) ? "" : h;
  }, [html]);

  useEffect(() => {
    const root = ref.current;
    if (!root || !resolveImage) return undefined;
    let cancelled = false;
    root.querySelectorAll("img[data-attachment-id]").forEach((img) => {
      const id = img.getAttribute("data-attachment-id");
      if (!cache.current.has(id)) {
        cache.current.set(
          id,
          Promise.resolve(resolveImage(id)).catch(() => {
            cache.current.delete(id);
            return null;
          })
        );
      }
      cache.current.get(id).then((url) => {
        if (!cancelled && url) img.setAttribute("src", url);
      });
    });
    return () => {
      cancelled = true;
    };
  }, [safe, resolveImage]);

  return (
    <div
      ref={ref}
      className={`text-sm text-gray-800 break-words [&_h2]:text-lg [&_h2]:font-SemiBold [&_h3]:text-base [&_h3]:font-SemiBold [&_ul]:list-disc [&_ul]:pl-5 [&_ol]:list-decimal [&_ol]:pl-5 [&_blockquote]:border-l-4 [&_blockquote]:border-gray-300 [&_blockquote]:pl-3 [&_blockquote]:text-gray-600 [&_code]:bg-gray-100 [&_code]:px-1 [&_code]:rounded [&_pre]:bg-gray-100 [&_pre]:p-2 [&_pre]:rounded [&_a]:text-blue-600 [&_a]:underline [&_img]:max-w-full [&_img]:rounded ${className}`}
      dangerouslySetInnerHTML={{ __html: safe }}
    />
  );
}

export default RichTextView;
